















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import vSelect from 'vue-select';
import { required } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { OrgsApi, Product, ProductsApi } from '../../../../api';
import Toast from '@/components/display/toast.vue';
import SitePicker from '@/components/site-picker.vue';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import {
	getDirectPlans,
	getPartnerPlans,
	hasPartnerPlan,
	OrdwayPlan,
	ProductOrdwayAttributes,
} from '@/models/ordway';
import { OrdwayService } from '@/services/ordway-service';
import { AxiosError, AxiosResponse } from 'axios';
import { Constants } from '@/common/Constants';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
@Component({
	components: {
		SaveCancelButtons,
		secondaryNav,
		vSelect,
		SitePicker,
	},
	validations: {
		form: {
			site: { required },
		},
	},
	mixins: [validationMixin],
})
export default class ProductUpdate extends Vue {
	get productPlans(): Array<{ value: string; text: string }> {
		if (this.product !== null) {
			return getDirectPlans(
				this.plans,
				this.product.type,
				this.form.supplier,
				this.$auth.user().billing,
			).map((plan: OrdwayPlan) => ({ value: plan.id, text: plan.name }));
		} else {
			return [];
		}
	}

	get partnerPlans(): Array<{ value: string; text: string }> {
		if (this.product !== null) {
			return getPartnerPlans(
				this.plans,
				this.product.type,
				this.form.supplier,
				this.$auth.user().billing,
			).map((plan: OrdwayPlan) => ({ value: plan.id, text: plan.name }));
		} else {
			return [];
		}
	}

	get productHasPartnerPlan(): boolean {
		const currentProductPlan = this.plans.find((plan: OrdwayPlan) => plan.id === this.form.plan);
		if (currentProductPlan !== undefined) {
			return hasPartnerPlan(currentProductPlan);
		}
		return false;
	}

	public form = {
		plan: '',
		partnerPlanId: '',
		site: {},
		name: '',
		supplier: '',
	};

	public product: any = null;

	public $bvToast: any;
	public loading = true;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public isOnNewOrdwayPlan: boolean | null = null;

	private plans: OrdwayPlan[] = [];
	private productOrdwayAttributes: ProductOrdwayAttributes | null = null;
	private partnerProductOrdwayAttributes: ProductOrdwayAttributes | null = null;
	private fuelSuppliers: Array<{ text: string; value: string; orgId: number }> = [];
	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
	}

	@Watch('form.plan')
	public onPlanChanged(newPlanId: string) {
		if (this.productOrdwayAttributes !== null) {
			const newPlan: OrdwayPlan | undefined = this.plans.find(
				(plan: OrdwayPlan) => plan.id === newPlanId,
			);
			if (newPlan !== undefined && newPlan.levno_plan_type !== 'directWithPartner') {
				this.form.partnerPlanId = '';
			}
		}
	}

	@Watch('form.supplier')
	public onSupplierChanged(newSupplier: string) {
		if (newSupplier === this.product.supplier) {
			if (this.productOrdwayAttributes !== null) {
				this.form.plan = this.productOrdwayAttributes.ordwayPlanId;
			}
			if (this.partnerProductOrdwayAttributes !== null) {
				this.form.partnerPlanId = this.partnerProductOrdwayAttributes.ordwayPlanId;
			}
		} else {
			this.form.plan = '';
			this.form.partnerPlanId = '';
		}
	}

	public async getPartnerOrgsByProductType() {
		try {
			const response = await new OrgsApi().orgGetPartnersByProductType('fuel');
			this.fuelSuppliers = response.data.data.map(supplier => {
				return { text: supplier.name, value: supplier.supplierCode, orgId: supplier.id };
			});
		} catch (e) {
			console.log(e);
		}
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const selectedOrdwayPlan: OrdwayPlan | undefined = this.plans.find(
			(plan: OrdwayPlan) => plan.id === this.form.plan,
		);
		const selectedPartnerPlan: OrdwayPlan | undefined = this.plans.find(
			(plan: OrdwayPlan) => plan.id === this.form.partnerPlanId,
		);

		const { productId } = this.$route.params;
		const product: Product = this.product;
		const supplierHasChanged = product.supplier !== this.form.supplier;
		product.name = this.form.name;
		if (selectedOrdwayPlan) {
			product.plan = selectedOrdwayPlan!.levno_product_tier;
		}
		product.siteId = this.form.site.id;
		product.supplier = this.form.supplier;
		let response: AxiosResponse<any>;
		try {
			response = await new ProductsApi().updateProduct(parseInt(productId, 10), { data: product });
		} catch (e) {
			let error;
			if (e.response) {
				error = 'Product not updated ' + e.response.data.message;
			} else if (e.request) {
				error = 'Product not updated, network Error';
			} else {
				error = 'Product not updated, unknown Error';
			}
			new Toast().makeToast(error, 'Error Updating Product', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}
		const isOnNewOrdwayPlan = await OrdwayService.isOnNewOrdwayPlan(
			this.product,
			this.productOrdwayAttributes,
		);
		if (this.product.status != 'removed' && !isOnNewOrdwayPlan) {
			const subscriptionUpdateResponse = await OrdwayService.updateSubscription(
				this.product.id,
				selectedOrdwayPlan!,
				this.getSupplierOrgId(product.supplier),
				selectedPartnerPlan,
			);
			if (subscriptionUpdateResponse) {
				if (subscriptionUpdateResponse.shouldToast) {
					new Toast().makeToast(subscriptionUpdateResponse.message, 'Ordway', 'warning', true);
				}
				if (subscriptionUpdateResponse.error !== undefined) {
					new Toast().makeToast(
						subscriptionUpdateResponse.message,
						'Error updating Ordway plan',
						'danger',
						true,
					);
					this.submitStatus = 'ERROR';
					return;
				}
			}
		}
		new Toast().makeToast('Product Updated', 'Successfully', 'success');

		setTimeout(() => {
			this.submitStatus = 'OK';
			this.$router.push({ name: 'products.fuel.view', params: { productId } });
		}, 1000);
	}

	public async load() {
		const { productId } = this.$route.params;
		this.submitStatus = 'OK';
		this.loading = true;

		try {
			const response = await this.api.getProductById(parseInt(productId, 10), {
				params: { include: 'org,site,subscriptionitem' },
			});
			const product: Product = response.data;
			this.form.supplier = product.supplier;

			if (product.subscriptionitem !== null) {
				this.form.plan = product.subscriptionitem.plan;
			} else {
				this.form.plan = product.plan;
			}
			this.form.site = product.site;
			this.form.name = product.name;

			this.product = product;
			this.loadOrdwayPlans();
		} catch (e) {
			this.product = null;
		}
	}

	public created() {
		this.load();
		this.getPartnerOrgsByProductType();
	}

	// Load all the Ordway plans - to be filtered down for all possible plan options in dropdown.
	private loadOrdwayPlans(): void {
		OrdwayService.fetchOrdwayPlans(Constants.PRODUCT_TYPE_FUEL).then(
			async (plans: OrdwayPlan[]) => {
				this.plans = plans;
				await this.fetchProductOrdwayAttributes();
			},
		);
	}

	private async fetchProductOrdwayAttributes(): Promise<void> {
		await this.fetchDirectOrdwayAttributes().catch(axiosError => {
			const error = axiosError as AxiosError;
			if (
				error.response &&
				error.response.data.errors === 'No matching product ordway attributes found'
			) {
				this.form.plan = '';
				new Toast().makeToast(
					'No direct subscription was found for this product - please let the software team know',
					'No direct plan set up',
					'danger',
					true,
				);
			}
			this.loading = false;
		});
		this.isOnNewOrdwayPlan = await OrdwayService.isOnNewOrdwayPlan(
			this.product,
			this.productOrdwayAttributes,
		);
		this.loading = false;
	}

	// Get the current plan id this product is on. This is not current attached to product model - todo ?
	private async fetchDirectOrdwayAttributes(): Promise<void> {
		const productOrdwayAttributesResponse = await OrdwayService.fetchProductOrdwayAttributes(
			this.product.id,
			this.product.orgId,
		);
		this.productOrdwayAttributes = productOrdwayAttributesResponse.data;
		this.form.plan = this.productOrdwayAttributes.ordwayPlanId;
	}

	private getSupplierOrgId(selectedSupplier?: string): number | undefined {
		if (selectedSupplier) {
			const supplier = this.fuelSuppliers.find(supplier => supplier.value === selectedSupplier);
			if (supplier) {
				return supplier.orgId;
			}
		}
	}
}
